

export interface EAddress {
    id: number;
    /** Check EaType for available type codes */
    type: number;
    junk: boolean;
    priority: number;
    value: string;
    raw?: string;
    tags?: string[];
}

export interface EAddressWithSource extends EAddress {
    source: string;
}

/** Known EAddress types */
export const EaType = {
    UNKNOWN: 0,
    EMAIL: 1,
    PHONE: 2,
    WEB: 3,
    SKYPE: 5,
    FACEBOOK: 6,
    TWITTER: 7,
    LINKEDIN: 8,
    NOSTR: 9,
    YOUTUBE: 10,
    INSTAGRAM: 11,
    TIKTOK: 12,
    PINTEREST: 13,
    SIGNAL: 14,
    TELEGRAM: 15,
    WHATSAPP: 16
};
